import { render, staticRenderFns } from "./ConfirmProfileSchool.vue?vue&type=template&id=cd9d7cf4&scoped=true&"
import script from "./ConfirmProfileSchool.vue?vue&type=script&lang=js&"
export * from "./ConfirmProfileSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9d7cf4",
  null
  
)

export default component.exports